import { render } from "./Inp-Person-1.vue?vue&type=template&id=b66ff4a8&scoped=true"
import script from "./Inp-Person-1.vue?vue&type=script&lang=js"
export * from "./Inp-Person-1.vue?vue&type=script&lang=js"

import "./Inp-Person-1.vue?vue&type=style&index=0&id=b66ff4a8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b66ff4a8"]])

export default __exports__